// extracted by mini-css-extract-plugin
export var footer = "_pv-5";
export var fulfillmentInput = "_pv-0";
export var shipDateInput = "_pv-1";
export var shipmentModal = "_pv-2";
export var shipmentModalContent = "_pv-3";
export var tableContainer = "_pv-4";